var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Button,
    {
      staticClass: "d-block btn-sm w-100 text-start",
      attrs: { title: _vm.title },
    },
    [
      _setup.className
        ? _c("i", { staticClass: "me-2", class: _setup.className })
        : _vm._e(),
      _vm._v("\n    " + _vm._s(_vm.title) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }